import React, { useState } from 'react';
import useSearchDebouncedEvents from './hooks/useSearchDebouncedEvents';
import { SearchWrapper, StyledCircularProgress, StyledClear, StyledSearch, StyledTextField, } from './StylovyzeSearchBar.styles';
/**
 * A SearchBar using MUI (without `material-ui-search-bar` dependency)
 * @param value * For controlled component pass a `value`, `setValue` in order to use an external value
 * @param setValue * For controlled component pass a `value`, `setValue` in order to use an external value
 */
const StylovyzeSearchBar = (props) => {
    const { handleSearchSubmit, dataCy, searchInProgress, style, className, placeholder, textFieldProps, debounce, debounceTime, pinClearButton, handlePinnedClearButton, onRequestSearch, onCancelSearch, onChange: onBarChange, } = props;
    const [value, setValue] = useState(props.value || '');
    const onChange = (e) => {
        textFieldProps?.onChange && textFieldProps?.onChange(e);
        onBarChange && onBarChange(e.target.value);
        setValue(e.target.value);
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && (handleSearchSubmit || onRequestSearch)) {
            const target = event?.target;
            if (handleSearchSubmit)
                handleSearchSubmit(target?.value);
            if (onRequestSearch)
                onRequestSearch();
        }
    };
    const handleClear = () => {
        setValue('');
        if (props.setValue)
            props.setValue('');
        if (pinClearButton) {
            if (handlePinnedClearButton)
                handlePinnedClearButton();
        }
        else {
            if (handleSearchSubmit)
                handleSearchSubmit('');
        }
        if (onCancelSearch)
            onCancelSearch();
    };
    const { onChange: handleChange } = useSearchDebouncedEvents({
        onChange,
        onDebounceChange: e => {
            if (e.target && handleSearchSubmit) {
                const target = e?.target;
                handleSearchSubmit(target?.value);
            }
        },
        debounceTime,
    });
    return (React.createElement(SearchWrapper, { style: style, className: className },
        React.createElement(StyledSearch, { onClick: () => {
                if (onRequestSearch) {
                    onRequestSearch();
                }
            }, color: "secondary" }),
        React.createElement(StyledTextField, { ...textFieldProps, margin: "normal", variant: "outlined", onKeyDown: e => {
                if (!(debounce || debounceTime)) {
                    handleKeyDown(e);
                }
            }, onChange: e => {
                if (!(debounce || debounceTime)) {
                    onChange(e);
                }
                else {
                    handleChange(e);
                }
            }, placeholder: placeholder, "data-cy": dataCy, value: value, disabled: searchInProgress }),
        searchInProgress && React.createElement(StyledCircularProgress, { size: 20 }),
        !searchInProgress && (React.createElement(React.Fragment, null,
            pinClearButton && React.createElement(StyledClear, { onClick: handleClear }),
            !pinClearButton && value && (React.createElement(StyledClear, { onClick: handleClear }))))));
};
export default StylovyzeSearchBar;
